import { render, staticRenderFns } from "./EmailTemplateInsertEditor.vue?vue&type=template&id=174d53a2&scoped=true"
import script from "./EmailTemplateInsertEditor.vue?vue&type=script&lang=js"
export * from "./EmailTemplateInsertEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174d53a2",
  null
  
)

export default component.exports